export const upGradService = [
  { name: "About", href: "https://www.upgrad.com/about" },
  { name: "upGrad In Media", href: "https://www.upgrad.com/media" },
  { name: "Careers", href: "https://www.upgrad.com/career" },
  { name: "upGrad Blog", href: "https://www.upgrad.com/blog" },
  { name: "Success Stories", href: "https://www.upgrad.com/success-stories" },
];
export const supportService = [
  { name: "Terms & Conditions", href: "https://www.upgrad.com/terms" },
  { name: "Privacy Policy", href: "https://www.upgrad.com/privacy" },
];

export const iconList = [
  { icon: "icon-upgrad-facebook", href: "https://www.facebook.com/upGradGlobal" },
  { icon: "icon-upgrad-twitter", href: "https://twitter.com/upGrad_edu" },
  { icon: "icon-upgrad-linkedin", href: "https://www.linkedin.com/company/ueducation" },
  { icon: "icon-upgrad-youtube", href: "https://www.youtube.com/c/UpGradGlobal" },
];
